import PillFilters from './PillFilters';

export default PillFilters;
